__turbopack_context__.v({
  "bottomad_layout": "Layout-module__cbqlla__bottomad_layout",
  "containerWithMargin_layout": "Layout-module__cbqlla__containerWithMargin_layout",
  "container_layout": "Layout-module__cbqlla__container_layout",
  "fallbackRightRailContainer_layout": "Layout-module__cbqlla__fallbackRightRailContainer_layout",
  "noContainerMargin": "Layout-module__cbqlla__noContainerMargin",
  "noTopAd_layout": "Layout-module__cbqlla__noTopAd_layout",
  "paddingTop_layout": "Layout-module__cbqlla__paddingTop_layout",
  "right_rail_add_layout": "Layout-module__cbqlla__right_rail_add_layout",
  "topad_layout": "Layout-module__cbqlla__topad_layout",
});
